import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Chaque fois que l'URL change -> remonte en haut
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // animation fluide
    });
  }, [pathname]);

  return null; // pas d'affichage
}
